
interface ProtectionItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const ProtectionItem = ({ icon, title, description }: ProtectionItemProps) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-4">
        <div className="p-3 bg-white rounded-full shadow-md">
          {icon}
        </div>
      </div>
      <h4 className="font-semibold text-gray-900 mb-2">{title}</h4>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  );
};

export default ProtectionItem;
